import { render, staticRenderFns } from "./confirmationForm.vue?vue&type=template&id=a83a7db0&scoped=true&"
import script from "./confirmationForm.vue?vue&type=script&lang=js&"
export * from "./confirmationForm.vue?vue&type=script&lang=js&"
import style0 from "./confirmationForm.vue?vue&type=style&index=0&id=a83a7db0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83a7db0",
  null
  
)

export default component.exports